import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColourPickerService {
  selctedColor:any='#EEA3C6';
  showColorPallateContainer:boolean=false;
  constructor() { }
}
